import { FC } from "react";
import { useDropzone } from 'react-dropzone';
import theme from "src/theme/light";
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import { Button } from "@material-ui/core";
import { notifierStore } from "src/framework/store";

export interface DropZoneProperties {
    disabled: boolean;
    multiple: boolean,
    onChange?: Function;
    formatosAceitos?: string[];
    keyRow?: string;
}

function formatBytes(bytes: number, decimals = 2) {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['bytes', 'kb', 'mb', 'gb'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + sizes[i];
}

const DropZone: FC<DropZoneProperties> = ({
    disabled,
    multiple,
    onChange = () => { },
    formatosAceitos,
    keyRow,
}) => {

    const { getRootProps, getInputProps } = useDropzone({
        disabled: disabled,
        multiple: multiple,
        onDropAccepted: (_files) => {

            const arquivos = [];

            for (let file of _files) {
                arquivos.push({
                    nome: file.name,
                    tamanho: formatBytes(file.size),
                    arquivo: file,
                    keyRow: keyRow
                })
            }

            onChange(arquivos);
        },
        onDropRejected: (_files) => {
            notifierStore.setNotifier({
                title: "Aviso",
                content: "Arquivo em fomato não permitido!",
                timeOut: 3500,
                onClose: () => {
                    notifierStore.setOpen(false)
                }
            })
            notifierStore.setOpen(true)

            return
        },
        accept: formatosAceitos,
    });

    return <>
        <div className="DropZone" style={{height: "100%"}}>
            <div {...getRootProps({ className: 'dropzone' })} style={{
                display: "flex",
                height: "100%",
                width: "100%",
                color: `${theme.palette.grey[500]}`,
                border: `dashed 2px ${theme.palette.grey[500]}`,
                background: `${theme.palette.grey[300]}`,
                borderRadius: theme.shape.borderRadius,
                textAlign: "center",
                alignContent: "center",
                alignItems: "center",
                justifyItems: "center",
                justifyContent: "center",
            }}>
                <input {...getInputProps()} type="file"/>
                <div style={{display: "flex", justifyContent: "center", flexDirection: "column"}}>
                    <div><CloudUploadIcon style={{ width: "2em", height: "2em" }} /></div>
                    <div style={{color: "#00A335FF"}}>Selecionar Arquivo</div>
                </div>

            </div>
        </div>
    </>
}

export { DropZone };